module.exports = __webpack_public_path__ + "img/img_011@2x.16e98fae.png";